import {helpers} from '../common/helpers';
import Swiper from 'swiper/dist/js/swiper.js';
import {ImageSlider, setPagerTranslate} from './sliders.js';
// import {ButtonsBehavior} from './other.js';

export let modalsBehavior = {
	slider: null,
	button: null,
	prevModal: null,
	isPolicyFromModal: false,
	currentAlias: null,

	isAliasinUrl: false,

	checkUrl() {
		if (location.pathname === '/') {
			let hash = location.hash.split('#')[1];
			let elem = $(`[data-alias="${hash}"]`)[0];

			if (elem) {
				this.isAliasinUrl = true;
				$(elem).trigger('click');
			}
		} else {
			let locSplit = location.pathname.split('/').filter(item => item !== '');
			let alias = locSplit[locSplit.length - 1];
			let elem = $(`[data-alias="${alias}"]`).length ? $(`[data-alias="${alias}"]`)[0] : $(`[data-slug="${alias}"]`)[0];

			if (elem) {
				this.isAliasinUrl = true;
				$(elem).trigger('click');
			}
		}
	},

	showModal(data, content, currentAlias) {
		let buttonData = data;

		if ($('html').hasClass('is-device-desktop')) {
			$('html').css('marginRight', helpers.getScrollBarWidth());
		}

		if (content) {
			if (data === 'formsuccess') {
				$('.modal-formsuccess__inner').html(content);
			} else {
				$('.modal-more-container').html(content);
				typeof window.setModalEvents === 'function' && window.setModalEvents($('.modal-more-container'));
			}
		}

		$(document).trigger('popup.Open');

		$(`.modal.-${buttonData}`).removeClass('is-hidden');
		$('body').addClass('is-modal-opened');

		$(`.modal.-${buttonData}`).find('.modal__inner').one('animationend webkitAnimationEnd oAnimationEnd', () => {
			if ($(`.modal.-${buttonData}`).find('.modal__cross')[0].crossBehav) {
				$(`.modal.-${buttonData}`).find('.modal__cross')[0].crossBehav.setOffset();
			}
		});

		if (content && data === 'more') {
			let $container = $('.modal-more-container');

			if ($container.find('.swiper-container').length) {
				this.slider = new Swiper($('.modal-more-container').find('.swiper-container'), {
					slidesPerView: 1,
					navigation: {
						prevEl: $('.modal-more-container').find('.slider-btn--prev')[0],
						nextEl: $('.modal-more-container').find('.slider-btn--next')[0],
					},
					pagination: {
						el: $('.modal-more-container').find('.slider-pagination__inner')[0],
						type: 'bullets',
						renderBullet(index, className) {
							return `<div class="slider-pagination__item ${className}"></div>`;
						},
					},
					on: {
						init() {
							if (this.slides.length <= 1) {
								$container.find('.modal-article__slidernav').addClass('is-hidden');
							}
						},
						slideChange() {
							setPagerTranslate(this.pagination.$el, this.activeIndex);
						},
					}
				});
			} else {
				this.slider = new ImageSlider($container.find('.image-slider'), {
					btnPrev: $container.find('.slider-btn--prev'),
					btnNext: $container.find('.slider-btn--next'),
					pager: $container.find('.slider-pagination__inner'),
					swipe: true,
					pagItem(slideNum) {
						return `<div class="slider-pagination__item" data-slide="${slideNum}"></div>`;
					},
					onChange(currentSlide, nextNum) {
						let elem = $container.find('.modal-props__slider__desc');

						setPagerTranslate(this.$pager, nextNum);

						if ($(`.c-slider-item[data-slide="${nextNum}"]`).hasClass('is-dark')) {
							$container.find('.modal-props__slider').addClass('is-controls-white');
						} else {
							$container.find('.modal-props__slider').removeClass('is-controls-white');
						}

						if (elem.length) {
							new TimelineMax({
								onComplete() {
									TweenMax.set($(elem).find('.text'), {
										opacity: 1,
									});
								},
							})
								.to($(elem).find('.text'), 0.5, {
									opacity: 0,
								})
								.add(() => {
									$(elem).find('.text').addClass('is-hidden');
									$(elem).find(`.text[data-slide="${nextNum}"]`).removeClass('is-hidden');
								})
								.to($(elem).find(`.text[data-slide="${nextNum}"]`), 0.6, {
									opacity: 1,
								});
						}
					},
				});
			}

			if (currentAlias) {
				let curPath;

				if (!this.isAliasinUrl) {
					curPath = location.pathname === '/' ? `#${currentAlias}` : `/${location.pathname.replace(/^\/|\/$/g, '')}/${currentAlias}`
					history.pushState(null, null, curPath);
				}

				this.currentAlias = currentAlias;
			}
		}

		if (data === 'form') {
			if ($('body').hasClass('page-park')) {
				let $checkboxes = $(`.modal.-${buttonData}`).find('input[type="checkbox"]:not([name="agree"])');

				$checkboxes.prop('checked', false);

				if ($('.park-futuro').length) {
					$(`.modal.-${buttonData}`).find('input[type="checkbox"][name="park-futuro"]').prop('checked', true);
				}

				if ($('.park-avenue').length) {
					$(`.modal.-${buttonData}`).find('input[type="checkbox"][name="park-avenue"]').prop('checked', true);
				}

				if ($('.park-fonte').length) {
					$(`.modal.-${buttonData}`).find('input[type="checkbox][name="park-fonte"]').prop('checked', true);
				}
			}
		}

		if (content && data === 'video') {
			$(`.modal.-${buttonData}`).find('.videoblock').append(content);
		}

		if (data !== 'agreement') {
			this.prevModal = {
				data,
				content,
			};
		}
	},

	hide(callback) {
		let self = this;

		new TimelineMax({
			onComplete() {
				$('.modal').scrollTop(0);

				$('html').removeAttr('style');
				$('.modal').addClass('is-hidden');
				$('.modal.-more').removeClass('is-article is-news');
				$('body').removeClass('is-modal-opened');

				$(document).trigger('popup.Close');

				if (self.slider) {
					if (self.slider.destroy) {
						self.slider.destroy();
					}
					self.slider = null;
				}

				if (self.button) {
					self.button.remove();
					self.button = null;
				}

				if (self.currentAlias) {
					if (location.pathname === '/') {
						history.pushState(null, null, `${location.href.split(`/#${self.currentAlias}`)[0]}`);
					} else {
						history.pushState(null, null, `${location.href.split(`/${self.currentAlias}`)[0]}`);
					}

					self.isAliasinUrl = false;
				}

				$('.modal-more-container').html('');
				$('.modal .videoblock').html('');

				if (callback) {
					callback();
				}
			},
		})
			.to($('.modal__inner'), 0.2, {
				scale: 0.8,
				clearProps: 'all',
			})
			.to($('.modal'), 0.2, {
				opacity: 0,
				clearProps: 'all',
			}, '-=0.2');
	},

	show(data, content, currentAlias) {
		if ($('body').hasClass('is-modal-opened')) {
			let callback = () => {
				this.showModal(data, content, currentAlias);
			};

			this.hide(callback);
		} else {
			this.showModal(data, content, currentAlias);
		}
	},
};

$('.js-modal-show').on('click', (e) => {
	let $button = $(e.currentTarget);
	let modal = $button.data('modal');
	let slug = $button.data('slug');

	switch( $button.data('form-name') ){
		case 'question':
			( typeof window.dsp_question == 'function' ) && window.dsp_question();
			break;
		case 'consult':
			( typeof window.dsp_consult == 'function' ) && window.dsp_consult();
			break;
		case 'overview':
			( typeof window.dsp_overview == 'function' ) && window.dsp_overview();
			break;
	}

	modalsBehavior.isPolicyFromModal = false;

	if ($button.hasClass('house-props__btn')) {

		$.get('/building/modal/' + slug + '/public',function(resp){
			modalsBehavior.show(modal, resp, slug);
		});

	} else {
		modalsBehavior.show(modal);
	}
});

$('.index-offers .variant-slider__item').on('click', (e) => {
	let alias = $(e.currentTarget).data('alias');

	$('.modal.-more').addClass('is-article');

    $.get('/offer/modal/' + alias + '/public',function(resp){
        modalsBehavior.show('more', resp, alias);
    });
});

$('.about-news .variant-slider__item').on('click', (e) => {
	let slug = $(e.currentTarget).data('slug');
    // history.pushState(null, null, `${location.href}#news-${alias}`);

	$('.modal.-more').addClass('is-article is-news');

    $.get('/news/modal/' + slug + '/public',function(resp){
        modalsBehavior.show('more', resp, slug);
    });
});


$('.form__agreement a').on('click', (e) => {
	e.preventDefault();

	if ($('body').hasClass('is-modal-opened')) {
		modalsBehavior.isPolicyFromModal = true;
	} else {
		modalsBehavior.isPolicyFromModal = false;
	}

	modalsBehavior.show('agreement');
});

$('.modal-agreement .button').on('click', (e) => {
	e.preventDefault();

	$('.form__agreement input[name="agree"]').each((i, elem) => {
		elem.checked = true;
	});

	if (modalsBehavior.isPolicyFromModal) {
		modalsBehavior.show(modalsBehavior.prevModal.data, modalsBehavior.prevModal.content);
	} else {
		modalsBehavior.hide();
	}
});

$('.modal.-agreement .modal__cross').on('click', (e) => {
	e.preventDefault();

	if (modalsBehavior.isPolicyFromModal) {
		modalsBehavior.show(modalsBehavior.prevModal.data, modalsBehavior.prevModal.content);
	} else {
		modalsBehavior.hide();
	}
});

$('.modal__cross, .modal').not('.modal.-agreement .modal__cross').on('click', () => {
	modalsBehavior.hide();
});

$('.modal__inner').on('click', (e) => {
	e.stopPropagation();
});

$('.modal__inner').on('click', '.form-success__btn', () => {
	modalsBehavior.hide();
});

$(document).on('keydown', (e) => {
	if (e.keyCode === 27) {
		modalsBehavior.hide();
	}
});

// sticky button in modals
class StickyCross {
	constructor($cross) {
		this.$cross = $cross;

		this.initCrossOffset = {
			top: 0,
			left: 0,
		};

		this.crossOffset = {
			top: 0,
			left: 0,
		};
	}

	setOffset() {
		let isSticky = false;
		let style;

		if (this.$cross.hasClass('is-sticky')) {
			// isSticky = true;
			// style = this.$cross.attr('style');

			return;
		}

		// if (isSticky) {
		// 	this.$cross.removeClass('is-sticky').removeAttr('style');
		// }

		let rectTop = this.$cross.offset().top - this.$cross.closest('.modal').offset().top;
		let rectLeft = this.$cross.offset().left - this.$cross.closest('.modal').offset().left;

		// if (isSticky) {
		// 	this.$cross.addClass('is-sticky').attr('style', style);
		// }

		this.initCrossOffset.top = rectTop;
		this.initCrossOffset.left = rectLeft;
	}
}

$('.modal__cross:not(.no-sticky)').each((i, elem) => {
	let crossBehav = new StickyCross($(elem));

	$(elem)[0].crossBehav = crossBehav;
});

$('.modal').on('scroll', (e) => {
	let $btn = $(e.currentTarget).find('.modal__cross');
	let crossBehav = $btn[0].crossBehav;

	if (!crossBehav) return;

	if ($(e.currentTarget).scrollTop() + 32 >= crossBehav.initCrossOffset.top) {
		$btn.addClass('is-sticky');
	} else {
		$btn.removeClass('is-sticky').removeAttr('style');
	}

	if ($btn.hasClass('is-sticky')) {
		$btn.css({
			position: 'fixed',
			top: 32,
			left: crossBehav.initCrossOffset.left,
		});
	}
});

// open modal on start
modalsBehavior.checkUrl();
